import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BottomTabBar } from '../components/mobile-toolkit/BottomTabBar';
import { QuickCheckInPanel } from '../components/mobile-toolkit/QuickCheckInPanel';
import { WalkUpRegistrationPanel } from '../components/mobile-toolkit/WalkUpRegistrationPanel';
import { GuestLookupPanel } from '../components/mobile-toolkit/GuestLookupPanel';
import { QrScannerPanel } from '../components/mobile-toolkit/QrScannerPanel';
import { LiveDashboardPanel } from '../components/mobile-toolkit/LiveDashboardPanel';
import { EmergencyContactsPanel } from '../components/mobile-toolkit/EmergencyContactsPanel';
import { RegistrationStatsPanel } from '../components/mobile-toolkit/RegistrationStatsPanel';
import { GxFeedPanel } from '../components/mobile-toolkit/GxFeedPanel';
import { DelegatePanelView } from '../components/mobile-toolkit/DelegatePanelView';
import type { ToolkitPanel } from '../components/mobile-toolkit/types';
import styles from './MobileOrganizerToolkitPage.module.css';

export function MobileOrganizerToolkitPage() {
  const [activePanel, setActivePanel] = useState<ToolkitPanel>('check-in');
  const navigate = useNavigate();

  function handleSwitchToLookup() {
    setActivePanel('lookup');
  }

  function renderPanel() {
    switch (activePanel) {
      case 'check-in':
        return <QuickCheckInPanel />;
      case 'walk-up':
        return <WalkUpRegistrationPanel />;
      case 'lookup':
        return <GuestLookupPanel />;
      case 'qr-scan':
        return <QrScannerPanel onSwitchToLookup={handleSwitchToLookup} />;
      case 'gx':
        return <GxFeedPanel />;
      case 'dashboard':
        return <LiveDashboardPanel />;
      case 'contacts':
        return <EmergencyContactsPanel />;
      case 'stats':
        return <RegistrationStatsPanel />;
      case 'panel':
        return <DelegatePanelView />;
    }
  }

  return (
    <div className={styles.page}>
      {/* Exit button — back to regular app */}
      <button
        onClick={() => navigate('/my-weekend')}
        style={{
          position: 'fixed',
          top: '12px',
          right: '12px',
          zIndex: 1100,
          background: 'rgba(15, 31, 23, 0.9)',
          border: '1px solid #2a5a3e',
          borderRadius: '20px',
          padding: '6px 14px',
          color: '#c9a84c',
          fontSize: '0.78rem',
          fontWeight: 600,
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          backdropFilter: 'blur(4px)',
        }}
        aria-label="Exit Mobile Toolkit"
      >
        ✕ Exit Toolkit
      </button>
      <div className={styles.panelContainer}>
        {renderPanel()}
      </div>
      <BottomTabBar activePanel={activePanel} onPanelChange={setActivePanel} />
    </div>
  );
}
